var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("badge", {
    attrs: {
      text: _vm.active ? _vm.activeText : _vm.inactiveText,
      color: _vm.active ? "green" : "red",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }